export const IX_BIDDABLE_SIZES = [
    "1x7v",
    "300x250",
    "300x600",
    "320x50",
    "728x90",
    "970x250"
];

export const SLOT_RENDER_EVENT = "slotRenderEnded";
export const SLOT_ONLOAD_EVENT = "slotOnload";
export const SLOT_RESPONSE_RECEIVED_EVENT = "slotResponseReceived";
export const SLOT_REQUESTED = "slotRequested";
